var map = {
	"./LOGO_PNG.png": 649,
	"./elegant-staircase.jpg": 740,
	"./hero-wood-workshop.jpg": 788,
	"./interior-paneling.jpg": 609,
	"./logo-prev.png": 975,
	"./outdoor-deck.jpg": 710,
	"./premium-furniture.jpg": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;